// Translation for bg
export const bg = {
        common: {
            save: 'Запази',
            cancel: 'Отмени',
            close: 'Затвори',
            delete: 'Изтрий',
            edit: 'Редактирай',
            activate: 'Активирай',
            add: 'Добави',
            saving: 'Запазване...',
            loading: 'Зареждане...',
            active: 'АКТИВЕН',
            inUse: 'В употреба',
            test: 'Тест',
            searchApps: 'Търси приложения...',
            betaBanner: 'BETA - Услугата все още не е налична!'
        },
        header: {
            creditBalance: 'Баланс',
            minutes: 'МИН'
        },
        auth: {
            signIn: 'Влез',
            signUp: 'Регистрация',
            username: 'Потребителско име',
            password: 'Парола',
            continue: 'Продължи',
            noAccount: 'Нямаш профил?',
            hasAccount: 'Вече имаш профил?',
            loginError: 'Грешка при вход',
            invalidCredentials: 'Невалидно потребителско име или парола',
            rateLimited: 'Твърде много опити за вход. Моля, изчакай малко.',
            sessionExpired: 'Твоята сесия е изтекла. Моля, използвай нова магическа връзка.',
            magicLinkInvalid: 'Връзката за вход е невалидна или е изтекла.',
            magicLinkSuccess: 'Добре дошъл! Успешно си се登вил.',
            magicLinkProcessing: 'Обработване на вход...',
            connectionError: 'Грешка при свързване. Моля, опитай отново.'
        },
        profile: {
            myProgress: 'Мой прогрес в обучението',
            signOut: 'Излез',
            plan: 'План: '
        },
        settings: {
            title: 'Настройки',
            tabs: {
                uiSettings: 'UI настройки',
                systemPrompt: 'Системна подсказка',
                llmProfiles: 'LLM профили',
                ttsProfiles: 'TTS профили',
                language: 'Език',
            },
            uiSettings: {
                title: 'Потребителски интерфейс',
                themeMode: 'Режим на тема',
                darkMode: 'Тъмен режим',
                lightMode: 'Светлинен режим',
                themeColor: 'Цвят на темата',
                themeColorDesc: 'Избери акцентния цвят за бутони, икони и маркирания',
                background: 'Фон',
                backgroundDesc: 'Избери фон за твоето работно пространство',
                selectBackgroundColor: 'Избери цвят на фона',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Фокус',
                    concentration: 'Концентрация',
                    relaxation: 'Релаксация',
                    lianas: 'Лиани',
                    color: 'Цвят'
                },
                backgroundColors: {
                    deepDark: 'Дълбок тъмен',
                    darkGrey: 'Тъмно сиво',
                    midnightBlue: 'Полунощно синьо',
                    indigo: 'Индиго',
                    darkTeal: 'Тъмен синьо-зелен',
                    brown: 'Кафяв',
                    darkRed: 'Тъмно червен',
                    deepPurple: 'Дълбок лилав',
                    pureWhite: 'Чисто бяло',
                    softWhite: 'Мягко бяло',
                    lightGrey: 'Светло сиво',
                    paleBlue: 'Бледо синьо',
                    paleGreen: 'Бледо зелено',
                    paleOrange: 'Бледо оранжево',
                    lavender: 'Лавандула',
                    blueGrey: 'Синьо-сиво'
                }
            },
            systemPrompt: {
                label: 'Системна подсказка:',
                placeholder: 'Зареждане на системната подсказка...',
                emptyError: 'Системната подсказка не може да бъде празна!',
                saveSuccess: '✓ Системната подсказка е запазена успешно!',
                loadError: 'Грешка при зареждане на системната подсказка',
                saveError: 'Грешка при запазване'
            },
            llmProfiles: {
                addButton: '+ Добави нова връзка',
                newConnection: 'Нова връзка',
                editConnection: 'Редактирай връзка',
                emptyState: 'Няма налични LLM връзки. Кликни по-долу, за да добавиш една.',
                loadingProfiles: 'Зареждане на профили...',
                nameLabel: 'Име *',
                namePlaceholder: 'напр. OpenAI GPT-4',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API ключ *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Модел *',
                modelPlaceholder: 'gpt-4, mistral-tiny, и т.н.',
                allFieldsRequired: 'Всички полета трябва да бъдат попълнени!',
                saveSuccess: '✓ Профилът е запазен успешно!',
                deleteConfirm: 'Сигурен ли си, че искаш да изтриеш "{name}"?',
                profileNotFound: 'Профилът не е намерен!',
                loadError: 'Грешка при зареждане на профили',
                saveError: 'Грешка при запазване',
                activateError: 'Грешка при активиране',
                deleteError: 'Грешка при изтриване',
                modelInfo: 'Модел: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Добави нов глас',
                newVoice: 'Нов глас',
                editVoice: 'Редактирай глас',
                emptyState: 'Няма налични TTS профили. Кликни по-долу, за да добавиш един.',
                loadingProfiles: 'Зареждане на TTS профили...',
                nameLabel: 'Име',
                namePlaceholder: 'напр. Мой ElevenLabs Adam',
                providerLabel: 'Доставчик',
                providerPlaceholder: 'напр. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Local)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API ключ *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'Модел ID *',
                modelIdPlaceholder: 'напр. eleven_monolingual_v1',
                voiceIdLabel: 'ID на глас',
                voiceIdPlaceholder: 'напр. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'Всички полета трябва да бъдат попълнени!',
                saveSuccess: '✓ TTS профилът е запазен успешно!',
                deleteConfirm: 'Сигурен ли си, че искаш да изтриеш "{name}"?',
                loadError: 'Грешка при зареждане на TTS профили',
                saveError: 'Грешка при запазване',
                activateError: 'Грешка при активиране',
                deleteError: 'Грешка при изтриване'
            },
            language: {
                title: 'Избери език',
                description: 'Избери предпочитания си език за потребителския интерфейс'
            },
        },
        chat: {
            ready: 'Готово',
            start: 'НАЧАЛО',
            stop: 'СТОП',
            initialMessage: 'Кликни НАЧАЛО за разговор в реално време.',
            listening: 'Слушам...',
            speaking: 'Thorsten говори...',
            userLabel: 'Ти',
            aiLabel: 'AI',
            modalTitle: 'Thorsten AI Chat',
            inputPlaceholder: 'Напиши съобщение...',
            send: 'Изпрати',
            loginRequired: 'Моля, влез в профила си, за да използваш този сервис.',
            loginButton: 'Влез сега',
            magicLinkRequired: 'Моля, използвай магическа връзка за вход.',
            creditLimitError: 'Твойта почасова квота е изчерпана. Актуализирай плана си (Medium/Premium), за да продължиш.',
            serviceDisabled: 'Услугата за чат в момента не е налична. Моля, опитайте отново по-късно.'
        },
        notifications: {
            error: 'Грешка',
            success: 'Успех',
            info: 'Информация',
            unknownError: 'Възникна неизвестна грешка'
        },
        cookie: {
            message: 'Този уебсайт използва бисквитки, за да ти предостави най-добрия възможен потребителски опит.',
            accept: 'Приеми'
        },
        curriculum: {
                buttonLabel: 'Учебна програма',
                buttonTitle: 'Покажи съдържанието на учебната програма',
                modalTitle: '{app} Учебна програма',
                sections: {
                    topic: 'Тема от учебната програма',
                    explanation: 'Обяснение за деца',
                    studentProfile: 'Профил на ученика'
                },
                topic: {
                    empty: 'Няма свързана тема от учебната програма с това микро-приложение в бекенда.',
                    missingDetail: 'Подробни данни за учебната програма за това микро-приложение все още не са налични в бекенда.',
                    learningGoals: 'Учебни цели',
                    prerequisites: 'Предварителни изисквания',
                    unitLabel: 'Раздел',
                    durationLabel: 'Продължителност',
                    difficultyLabel: 'Трудност',
                    hours: 'ч',
                    minutes: 'мин'
                },
                explanation: {
                    empty: 'Няма налично обяснение за деца.',
                    loadingPrepare: 'ИИ подготвя обяснението',
                    loadingExplain: 'ИИ обяснява темата на детски език',
                    requestFailed: 'Обяснението за деца не можа да бъде генерирано.'
                },
                studentProfile: {
                    country: 'Държава',
                    region: 'Област / Регион',
                    schoolType: 'Тип училище',
                    grade: 'Клас',
                    noContext: 'Няма наличен контекст за ученика.',
                    childProfileNotFound: 'Не е намерен профил на ученик в бекенда за текущото влизане.',
                    loginProfileIncomplete: 'Профилът за вход все още не съдържа пълен контекст за ученика.',
                    educationContextNotFound: 'Намерен е профил на ученик, но не е зададено назначение на учебна програма.',
                    noToken: 'Не е намерен влязъл ученик.'
                },
                errors: {
                    signInRequired: 'Моля, влезте, за да видите учебната програма.',
                    appIdMissing: 'Липсва ID на приложението.',
                    loadFailed: 'Неуспешно зареждане на данните за учебната програма.'
                }
            }
    };
